import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const reduceMotion = useReducedMotion();
  return <section id="faq" aria-labelledby="faq-heading" className="w-full scroll-mt-16 bg-ivory px-5 py-14 md:px-8 md:py-24" data-id="element-63" data-mp="2dyd93b4faaz2">
      <div className="mx-auto w-full max-w-3xl" data-id="element-64" data-mp="241h0l5eixoui">
        <Reveal data-id="element-65" data-mp="244cyitqdgdiy">
          <SectionHeading id="faq-heading" title="Frequently asked questions" data-id="element-66" data-mp="1z374mskz6k7u" />
        </Reveal>

        <div className="mt-12 overflow-hidden rounded-xl border border-charcoal/10 bg-white md:mt-14" data-id="element-67" data-mp="sn3fu9f2hpip">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const buttonId = `faq-button-${index}`;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} className={index > 0 ? 'border-t border-charcoal/10' : ''} data-id="element-68" data-mp="ugr3igaie6er" data-mpi={index}>
                <h3 data-id="element-69" data-mp="fk0d2witc51a">
                  <button id={buttonId} type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex min-h-[64px] w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-ivory md:px-7" data-id="element-70" data-mp="fkjorvhvdx6v">
                    <span className="text-base font-semibold text-charcoal md:text-[17px]" data-id="element-71" data-mp="3swk1hbesp5so">
                      {faq.question}
                    </span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-forest/20" data-id="element-72" data-mp="3jz1bdsmao19x">
                      {isOpen ? <MinusIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-73" data-mp="1ugup02zxentq" /> : <PlusIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-74" data-mp="1ppmbovvh6iba" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-75" data-mp="1frye7y6hiwpf">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduceMotion ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduceMotion ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: reduceMotion ? 0 : 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-76" data-mp="1fq3w0rmllip1">
                      <p className="px-5 pb-6 text-base leading-relaxed text-charcoal/80 md:px-7" data-id="element-77" data-mp="nzzdyzmb97qz">
                        {faq.answer}
                        {faq.linksRefundPolicy && siteConfig.refundPolicyUrl && <>
                            {' '}
                            <a href={siteConfig.refundPolicyUrl} className="font-semibold text-forest underline decoration-brass underline-offset-4" data-id="element-78" data-mp="38ok6vd5i19zk">
                              Read the refund policy
                            </a>
                            .
                          </>}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}